import { FC, ChangeEvent } from 'react';
import { FormControlLabel, Grid, Switch } from '@mui/material';
import { FormInput} from '../CoreLib/library';

export interface IPoAndJobNumberInputProps {
    formQuotePoNumber?: string;
    formIsCustomPoNumber: boolean;
    formPoNumber?: string;
    formQuoteCustomerJobNumber?: string;
    formIsCustomerJobNumberCustom: boolean;
    formCustomerJobNumber?: string;
    handleIsCustomPoNumberChange: (isCustomPoNumber: boolean) => void;
    handleIsCustomerJobNumberCustomChange: (isCustomerJobNumberCustom: boolean) => void;
    handleCustomerJobNumberChange: (customerJobNumber: ChangeEvent<HTMLInputElement>) => void;
    handlePoNumberChange: (poNumber: ChangeEvent<HTMLInputElement>) => void;
    fieldErrors?: Map<string, string>;
}

export const PoAndJobNumberInput: FC<IPoAndJobNumberInputProps> = props => {
    const { formQuotePoNumber,
        formIsCustomPoNumber,
        handleIsCustomPoNumberChange,
        formPoNumber,
        formQuoteCustomerJobNumber,
        formIsCustomerJobNumberCustom,
        formCustomerJobNumber,
        handleIsCustomerJobNumberCustomChange,
        handleCustomerJobNumberChange,
        handlePoNumberChange,
        fieldErrors } = props;

    return (
        <Grid container spacing={2}>
            <Grid item xs={12} sm={4} md={4} xl={4}>
                <FormInput 
                    value={formQuotePoNumber} 
                    onChange={() => {}} 
                    label='Quote PO Number' 
                    fullWidth
                    disabled/>
            </Grid>
            <Grid item xs={12} sm={2} md={2} xl={2} container alignItems="center" justifyContent="center">
                <FormControlLabel
                    control={<Switch checked={formIsCustomPoNumber} onChange={(event, value) => handleIsCustomPoNumberChange(value)} />}
                    label='Custom PO #'
                    labelPlacement='end'
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} xl={6}>
                <FormInput 
                    value={formPoNumber} 
                    onChange={(event) => handlePoNumberChange(event)} 
                    label='Line Item PO Number' 
                    fullWidth
                    disabled={!formIsCustomPoNumber}
                    maxLength={30}
                    required={true}
                    errorText={fieldErrors?.get('poNumber')}
                />
            </Grid>
            <Grid item xs={12} sm={4} md={4} xl={4}>
                <FormInput
                    value={formQuoteCustomerJobNumber}
                    onChange={(event) => handleCustomerJobNumberChange(event)}
                    label='Quote Job Number'
                    fullWidth
                    disabled
                />
            </Grid>
            <Grid item xs={12} sm={2} md={2} xl={2} container alignItems="center" justifyContent="center">
                <FormControlLabel
                    control={<Switch checked={formIsCustomerJobNumberCustom} onChange={(event, value) => handleIsCustomerJobNumberCustomChange(value)} />}
                    label='Custom Job #'
                    labelPlacement='end'
                />
            </Grid>
            <Grid item xs={12} sm={6} md={6} xl={6}>
                <FormInput 
                    value={formCustomerJobNumber}
                    onChange={(event) => handleCustomerJobNumberChange(event)} 
                    label='Line Item Job Number' 
                    fullWidth
                    disabled={!formIsCustomerJobNumberCustom}/>
            </Grid>
        </Grid>
    )
}